export default __webpack_public_path__ + "media/images/loader-150eb508.gif";